
import { Vue, prop } from "vue-class-component";
import { HangingLastMileSummary } from "@/domain/entities/HangingLastMile";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";

class Props {
  dataSummary = prop<HangingLastMileSummary>({
    default: () => ({}),
    type: Object,
  });
}

class HeaderSummaryHangingLastMile extends Vue.with(Props) {
  formatDate = formatDate

  get allCards() {
    // summary cards
    const summary = [
      {
        icon: require("@/app/ui/assets/svg/total-active-awb-hanging.svg"),
        alt: "total-active-hanging-last-mile",
        label: this.$t("dashboard.hanging.activity"),
        pending: this.dataSummary.activitiesPending,
        done: this.dataSummary.activitiesDone,
        total: this.dataSummary.totalActivities,
      },
      {
        icon: require("@/app/ui/assets/svg/kurir-hanging.svg"),
        alt: "total-kurir-hanging-last-mile",
        label: this.$t("dashboard.hanging.courier"),
        pending: this.dataSummary.courierHangingPending,
        done: this.dataSummary.courierHangingDone,
        total: this.dataSummary.totalCourierHanging,
      },
      {
        icon: require("@/app/ui/assets/svg/del-hanging.svg"),
        alt: "total-del-hanging-last-mile",
        label: "DEL",
        pending: this.dataSummary.delHangingPending,
        done: this.dataSummary.delHangingDone,
        total: this.dataSummary.totalDelHanging,
      },
      {
        icon: require("@/app/ui/assets/svg/dex-hanging.svg"),
        alt: "total-dex-hanging-last-mile",
        label: "DEX",
        pending: this.dataSummary.dexHangingPending,
        done: this.dataSummary.dexHangingDone,
        total: this.dataSummary.totalDexHanging,
      },
      {
        icon: require("@/app/ui/assets/svg/codrej-hanging.svg"),
        alt: "total-codrej-hanging-last-mile",
        label: "CODREJ",
        pending: this.dataSummary.codrejHangingPending,
        done: this.dataSummary.codrejHangingDone,
        total: this.dataSummary.totalCodrejHanging,
      },
    ];

    return [...summary];
  }
}
export default HeaderSummaryHangingLastMile;
